import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {I18n} from '@aws-amplify/core';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/MeterAssignmentsService.ts";
import {useMeterAssignmentsSelection} from "../hooks/useMeterAssignmentsSelection.ts";
import {meterAssignmentsQueryKeys} from "../hooks/useMeterAssignments.ts";
import {notifyError, notifySuccess} from "../../../components/ServiceNotifications";

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useMeterAssignmentsSelection();
    const queryClient = useQueryClient();

    // FNP-217: the MeterAssignment table is composite-key, so delete is by
    // { customerId, sortKey } — both present on the selected row — not by id.
    const mutation = useMutation({
        mutationFn: () => Promise.all(selectedRecords.map(record => deleteRecord({
            customerId: record.customerId,
            sortKey: record.sortKey,
        }))),
        onSuccess: () => {
            // Clear only once the deletes landed: a failed delete keeps the selection, so
            // the operator can see which rows it was and retry.
            clearSelection();
            notifySuccess(I18n.get('Meter Assignments deleted'));
            queryClient.invalidateQueries({queryKey: meterAssignmentsQueryKeys.all});
        },
        onError: notifyError,
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={() => mutation.mutate()}
        />
    );
};
